import React, { useRef, useState } from 'react';

import Carousel from 'antd/es/carousel';
import RightCircleOutlined from '@ant-design/icons/es/icons/RightCircleOutlined';
import LeftCircleOutlined from '@ant-design/icons/es/icons/LeftCircleOutlined';

import styles from '../Styles/publicRoutes/style.module.less';

export const SidepanelCarousel = ({ testimonials }: $TSFixMe) => {
  const {
    sidepanelTestCard,
    testCardTriangles,
    sidepanelTriangles,
    topRight,
    bottomLeft,
    rotated,
    testimonialHeading,
    testimonialBy,
    testimonialImg,
    nonPersonLogo,
    testimonialComment,
    sidepanelCarouselContainer,
    sidepanelCarousel,
    antCarousel,
    sidepanelScrollable,
    scrollInvisible,
    sidepanelCarouselControls,
    controlsIcon
  } = styles;
  const carouselRef = useRef();
  const [index, setIndex] = useState(0);

  const testimonialsCards = () => {
    return testimonials.map((testimonial: $TSFixMe) => (
      <div className={sidepanelTestCard} key={`${testimonial.heading}`}>
        <img
          src='https://storage.googleapis.com/falcon-shared-images-front-end/assets/svgs/triangles.svg'
          className={`${testCardTriangles} ${sidepanelTriangles} ${topRight}`}
          alt='Attentive Triangles'
        />
        <img
          src='https://storage.googleapis.com/falcon-shared-images-front-end/assets/svgs/triangles.svg'
          className={`${testCardTriangles} ${sidepanelTriangles} ${bottomLeft} ${rotated}`}
          alt='Attentive Triangles'
        />
        <div className='mb-3'>
          <h2 className={`${testimonialHeading} fw-bold-3 text-white`}>{testimonial.heading}</h2>
        </div>
        <div className='text-left'>
          <div className={testimonialBy}>
            <img
              className={`${testimonialImg} ${testimonial.user.isPersonImage ? '' : nonPersonLogo}`}
              src={testimonial.user.logo}
              alt=''
              loading='lazy'
            />
            <div className='ml-3'>
              <h6 className='fw-bold-3 fs-3 mb-0 text-white'>{testimonial.user.name}</h6>
              <span className='italic'>{testimonial.user.position}</span>
            </div>
          </div>

          <div className={`${testimonialComment} mt-4`}>{testimonial.comment}</div>
        </div>
      </div>
    ));
  };

  return (
    <div className={sidepanelCarouselContainer}>
      <Carousel
        // @ts-expect-error TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
        ref={carouselRef}
        className={`${sidepanelCarousel} ${antCarousel}`}
        dots={false}
        autoplay
        autoplaySpeed={3000}
        beforeChange={(_, next) => setIndex(next)}>
        {testimonialsCards()}
      </Carousel>

      <div className={`${sidepanelScrollable} ${scrollInvisible}`}>{testimonialsCards()}</div>

      <div className={`${sidepanelCarouselControls} mt-1`}>
        <LeftCircleOutlined
          className={controlsIcon}
          style={index === 0 ? { color: 'rgba(245, 245, 245, 0.3)' } : {}}
          onClick={() => {
            if (index > 0) {
              setIndex(index - 1);
              // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              carouselRef.current.prev();
            }
          }}
        />
        <span>
          {index + 1}/{testimonials.length}
        </span>
        <RightCircleOutlined
          className={controlsIcon}
          style={index === testimonials.length - 1 ? { color: 'rgba(245, 245, 245, 0.3)' } : {}}
          onClick={() => {
            if (index < testimonials.length - 1) {
              setIndex(index + 1);
              // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              carouselRef.current.next();
            }
          }}
        />
      </div>
    </div>
  );
};
